// @ts-check
// Backend 3e279ba3 (live on PROD 2026-09-30): unregister and regenerate-key REMOVE the licence's
// activation label (activationSecretHash and its tracking) in the write that reopens registration.
// When the licence had a label, the portal mints the replacement straight after either action
// succeeds, so the admin never needs a separate "Generate label" step. A licence onboarded by
// registration code (no label) gets no new label: it would only add an unneeded bearer credential.
// Every user-visible string for that flow lives HERE.
const LABEL_STOPS = 'Any current activation label stops working.';
const LABEL_NEXT = ' A new activation label is created next for you to give to the clinic.';
const ENABLE_FIRST = ' Enable the licence before the clinic scans it.';

export const LABEL_REISSUE_COPY = {
  unregisterBody: (hasLabel) =>
    `The tablet registered to this licence loses access. ${LABEL_STOPS}${hasLabel ? LABEL_NEXT : ''}`,
  regenerateBody: (hasLabel) =>
    'This issues a new licence key and unregisters any tablet on this licence; that tablet loses access. '
    + `${LABEL_STOPS}${hasLabel ? LABEL_NEXT : ''}`,
  unregisteredNotice: (serialNumber, isActive) =>
    `The device is unregistered and the old activation label for ${serialNumber} no longer works. `
    + `Give this new activation label to the clinic.${isActive ? '' : ENABLE_FIRST}`,
  regeneratedNotice: (serialNumber, isActive) =>
    `The key is regenerated and the old activation label for ${serialNumber} no longer works. `
    + `Give this new activation label to the clinic.${isActive ? '' : ENABLE_FIRST}`,
  failureNotice:
    'The new activation label could not be created. The licence stays unregistered and the old label '
    + 'does not work. Retry to create the new label. You can also create it later from Generate activation labels.',
};
